import React, { Component } from "react";
import imgUrl from "../../../../styles/img/icon-baby-grey-little.svg";
import _ from "lodash";
import srcIconPhoto from "../../../../styles/img/icon-photo.svg";
import { connect } from "react-redux";
import { getAccount } from "../../../../modules/auth/Auth.ducks";
import ModalHoraires from "../fiche-enfant/les-tabs/ModalHoraires";
import { postEnfantSimple } from "../creche/creche.ducks";
import moment from "moment";
import { toUpperCaseFirst, toLowerCaseFirst } from "../../../../ReactConst";
import imgUrlAvatar from "../../../../styles/img/enfant-avatar.jpg";
import { css } from "@emotion/core";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import DateFnsUtils from "@date-io/moment";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import ModalCancelAdd from "./ModalCancelAdd";
import ModalConfirmAdd from "./ModalConfirmAdd";
import { API } from "../../../../const";
import { Service } from "../../../service/service";
import { isMobile } from "react-device-detect";
import { makeStyles } from "@material-ui/core/styles";
import UploadMobile from "../fiche-enfant/les-tabs/UploadMobile";
import ModalePhoto from "../fiche-enfant/les-tabs/ModalePhoto";
import { withTranslation } from 'react-i18next';

const materialTheme = createMuiTheme({
  palette: {
    primary: { main: "#1d4cc5" },
  },
  overrides: {
    MuiInputBase: {
      root: {
        position: "relative",
        boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none",
        padding: "0 15px",
        fontWeight: "600",
        fontSize: "18px",
        color: "#000",
      },
      input: {
        textAlign: "center",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none !important",
        fontWeight: "normal",
        fontSize: "18px",
        color: "#000",
      },
    },
    MuiInput: {
      underline: {
        "&::before": {
          content: "none",
        },
        "&::after": {
          content: "none",
        },
      },
    },
  },
});
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

// CSS for Image avatar
const divStyleAvatar = {
  color: "white",
  backgroundImage: "url(" + imgUrlAvatar + ")",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  backgroundSize: "cover",
  position: "relative",
  width: "65px",
  height: "55px",
};
// CSS for photo enfant
const IconPhoto = () => (
  <object data={srcIconPhoto} type="image/svg+xml" className="img-fluid" />
);
var divStyle = {
  backgroundImage: "url(" + imgUrl + ")",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
};

let horaires = {
  MONDAY: {
    ouvert: false,
    horaireDebut: null,
    horaireFin: null,
  },
  TUESDAY: {
    ouvert: false,
    horaireDebut: null,
    horaireFin: null,
  },
  WEDNESDAY: {
    ouvert: false,
    horaireDebut: null,
    horaireFin: null,
  },
  THURSDAY: {
    ouvert: false,
    horaireDebut: null,
    horaireFin: null,
  },
  FRIDAY: {
    ouvert: false,
    horaireDebut: null,
    horaireFin: null,
  },
  SATURDAY: {
    ouvert: false,
    horaireDebut: null,
    horaireFin: null,
  },
  SUNDAY: {
    ouvert: false,
    horaireDebut: null,
    horaireFin: null,
  },
};

class Creche extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numJour: 0,
      horaire: "",
      nomPrenom: "",
      dateNaissance: moment().format("YYYY-MM-DD"),
      dateAcceptation: moment().format("YYYY-MM-DD"),
      nomPrenomparent: "",
      telephone: "",
      parents: [
        {
          nom: "",
          prenom: "",
          email: "",
          adresse: { rue: "", ville: "", codePostal: "", pays: "" },
          situation: "MARIE",
          numeroTel: "",
          etatCompte: "",
          PrenomNom: "",
          fullAdress: "",
        },
        {
          nom: "",
          prenom: "",
          email: "",
          adresse: { rue: "", ville: "", codePostal: "", pays: "" },
          situation: "MARIE",
          numeroTel: "",
          etatCompte: "",
          PrenomNom: "",
          fullAdress: "",
        },
      ],
      tierces: [],
      showTierce: false,
      email: "",
      numeroTel: "",
      formErrors: { sexe: "", email: "", numeroTel: "", nomPrenom: "" },
      emailValid: true,
      numeroTelValid: true,
      formValid: true,
      newHoraires: {
        MONDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH[h]mm"),
          horaireFin: moment().format("HH[h]mm"),
          nameOfDay: this.props.t('days.monday'),
        },
        TUESDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH[h]mm"),
          horaireFin: moment().format("HH[h]mm"),
          nameOfDay: this.props.t('days.tuesday'),
        },
        WEDNESDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH[h]mm"),
          horaireFin: moment().format("HH[h]mm"),
          nameOfDay: this.props.t('days.wednesday'),
        },
        THURSDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH[h]mm"),
          horaireFin: moment().format("HH[h]mm"),
          nameOfDay: this.props.t('days.thursday'),
        },
        FRIDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH[h]mm"),
          horaireFin: moment().format("HH[h]mm"),
          nameOfDay: this.props.t('days.friday'),
        },
        SATURDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH[h]mm"),
          horaireFin: moment().format("HH[h]mm"),
          nameOfDay: this.props.t('days.saturday'),
        },
        SUNDAY: {
          ouvert: false,
          horaireDebut: null,
          horaireFin: null,
          nameOfDay: this.props.t('days.sunday'),
        },
      },
      newTierce: {
        PrenomNomTierce: "",
        numeroTel: "",
        nom: "",
        prenom: "",
        lienDeParente: "Ami",
      },
      couplageActif: false,
      ModalHoraires: false,
      horaireDebut: moment(),
      horaireFin: moment(),
      marcheActif: false,
      biberonActif: false,
      biberonFrequence: "",
      sexeEnfant: "",
      poidsEnfant: "",
      tailleEnfant: "",
      ModaleArchivage: false,
      ModaleSuppresion: false,
      ModalePhoto: false,
      etatCompte: "",
      showModalCancel: false,
      showModalConfirm: false,
      dataSubmit: {},
      lienPhoto: imgUrl,
      showPhoto: null,
    };
    this.onChangeNomParent = this.onChangeNomParent.bind(this);
    this.onChangeNomTierce = this.onChangeNomTierce.bind(this);
    this.showAddTierce = this.showAddTierce.bind(this);
    this.handleChangeMulitple = this.handleChangeMulitple.bind(this);
    this.toggle = this.toggle.bind(this);
    this.deleteTierce = this.deleteTierce.bind(this);
    this.showModalHoraires = this.showModalHoraires.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onSubmitModal = this.onSubmitModal.bind(this);
    this.handleChangeHoraire = this.handleChangeHoraire.bind(this);
    this.handleChangeTimeStart = this.handleChangeTimeStart.bind(this);
    this.handleChangeTimeEnd = this.handleChangeTimeEnd.bind(this);
    this.onChangeEnfant = this.onChangeEnfant.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.closeModalConfirm = this.closeModalConfirm.bind(this);
    this.openModalCancel = this.openModalCancel.bind(this);
    this.closeModalCancel = this.closeModalCancel.bind(this);
    this.validateSubmit = this.validateSubmit.bind(this);
    this.confirmSubmit = this.confirmSubmit.bind(this);
    this.showModalPhoto = this.showModalPhoto.bind(this);
    this.uploadPhoto = this.uploadPhoto.bind(this);
    this.onCloseModalePhoto = this.onCloseModalePhoto.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.onSelectFile = this.onSelectFile.bind(this);
    this.getCroppedImage = this.getCroppedImage.bind(this);
    this.uploadPhotoMobile = this.uploadPhotoMobile.bind(this);
    this.onCloseUploadMobile = this.onCloseUploadMobile.bind(this);
  }
  onCloseUploadMobile() {
    this.setState({ modalUploadMobile: false, file: "" });
  }

  uploadPhotoMobile = (e) => {
    e.preventDefault();
    let tok = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("file", this.state.croppedFile);
    const response = Service.post(
      `${API}api/creche/files?category=PHOTO`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${tok}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    response.then((res) => {
      setTimeout(() => {}, 400);
      this.setState({
        fileId: res.data.files[0].fileId,
        lienPhoto: this.state.croppedFile,
        modalUploadMobile: false,
      });
    });
    response.catch((err) => {});
  };
  getCroppedImage(file) {
    this.setState({ croppedFile: file });
  }
  showModalPhoto() {
    this.setState({ ModalePhoto: true });
  }
  onCloseModalePhoto() {
    this.setState({ ModalePhoto: false });
  }
  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      let sizeInMB = (e.target.files[0].size / (1024 * 1024)).toFixed(2);
      if (sizeInMB > 5) {
        let name = "";
        let message = this.props.t('validation.photo_too_large');
        this.props.openSnackBar(name, message);
      } else {
        const reader = new FileReader();
        reader.addEventListener("load", () =>
          this.setState({
            file: reader.result,
            isUpload: true,
            modalUploadMobile: true,
          })
        );
        reader.readAsDataURL(e.target.files[0]);
      }
    }
  };
  uploadPhoto = (file) => {
    let tok = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("file", file);
    const response = Service.post(
      `${API}api/creche/files?category=PHOTO`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${tok}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    response.then((res) => {
      this.setState({ fileId: res.data.files[0].fileId, showPhoto: file });
    });
    response.catch((err) => {});
  };
  onCloseModalePhoto() {
    this.setState({ ModalePhoto: false });
  }
  showModalPhoto() {
    this.setState({ ModalePhoto: true });
  }
  confirmSubmit() {
    this.props.postEnfantSimple(
      localStorage.getItem("token"),
      this.state.dataSubmit
    );
    this.setState({
      numJour: 0,
      horaire: "",
      nomPrenom: "",
      dateNaissance: moment().format("YYYY-MM-DD"),
      dateAcceptation: moment().format("YYYY-MM-DD"),
      nomPrenomparent: "",
      telephone: "",
      parents: [
        {
          nom: "",
          prenom: "",
          email: "",
          adresse: { rue: "", ville: "", codePostal: "", pays: "" },
          situation: "MARIE",
          numeroTel: "",
          etatCompte: "",
          PrenomNom: "",
          fullAdress: "",
        },
        {
          nom: "",
          prenom: "",
          email: "",
          adresse: { rue: "", ville: "", codePostal: "", pays: "" },
          situation: "MARIE",
          numeroTel: "",
          etatCompte: "",
          PrenomNom: "",
          fullAdress: "",
        },
      ],
      tierces: [],
      showTierce: false,
      email: "",
      numeroTel: "",
      formErrors: { email: "", numeroTel: "" },
      emailValid: true,
      numeroTelValid: true,
      formValid: true,
      newHoraires: {},
      newTierce: {},
      couplageActif: false,
      ModalHoraires: false,
      horaireDebut: moment(),
      horaireFin: moment(),
      marcheActif: false,
      biberonActif: false,
      biberonFrequence: null,
      sexeEnfant: "",
      poidsEnfant: "",
      tailleEnfant: "",
      ModaleArchivage: false,
      ModaleSuppresion: false,
      ModalePhoto: false,
      showModalCancel: false,
      showModalConfirm: false,
      etatCompte: "",
      lienPhoto: null,
      newHoraires: {
        MONDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH:mm"),
          horaireFin: moment().format("HH:mm"),
          nameOfDay: this.props.t('days.monday'),
        },
        TUESDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH:mm"),
          horaireFin: moment().format("HH:mm"),
          nameOfDay: this.props.t('days.tuesday'),
        },
        WEDNESDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH:mm"),
          horaireFin: moment().format("HH:mm"),
          nameOfDay: this.props.t('days.wednesday'),
        },
        THURSDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH:mm"),
          horaireFin: moment().format("HH:mm"),
          nameOfDay: this.props.t('days.thursday'),
        },
        FRIDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH:mm"),
          horaireFin: moment().format("HH:mm"),
          nameOfDay: this.props.t('days.friday'),
        },
        SATURDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH:mm"),
          horaireFin: moment().format("HH:mm"),
          nameOfDay: this.props.t('days.saturday'),
        },
        SUNDAY: {
          ouvert: false,
          horaireDebut: null,
          horaireFin: null,
          nameOfDay: this.props.t('days.sunday'),
        },
      },
      dataSubmit: {},
    });
  }
  closeModalConfirm(event) {
    this.setState({ showModalConfirm: false });
  }
  openModalCancel = (event) => {
    this.setState({ showModalCancel: true });
  };
  closeModalCancel = (event) => {
    this.setState({
      numJour: 0,
      horaire: "",
      nomPrenom: "",
      dateNaissance: moment().format("YYYY-MM-DD"),
      dateAcceptation: moment().format("YYYY-MM-DD"),
      nomPrenomparent: "",
      telephone: "",
      parents: [
        {
          nom: "",
          prenom: "",
          email: "",
          adresse: { rue: "", ville: "", codePostal: "", pays: "" },
          situation: "MARIE",
          numeroTel: "",
          etatCompte: "",
          PrenomNom: "",
          fullAdress: "",
        },
        {
          nom: "",
          prenom: "",
          email: "",
          adresse: { rue: "", ville: "", codePostal: "", pays: "" },
          situation: "MARIE",
          numeroTel: "",
          etatCompte: "",
          PrenomNom: "",
          fullAdress: "",
        },
      ],
      tierces: [],
      showTierce: false,
      email: "",
      numeroTel: "",
      formErrors: { email: "", numeroTel: "" },
      emailValid: true,
      numeroTelValid: true,
      formValid: true,
      newHoraires: {},
      newTierce: {},
      couplageActif: false,
      ModalHoraires: false,
      horaireDebut: moment(),
      horaireFin: moment(),
      marcheActif: false,
      biberonActif: false,
      biberonFrequence: null,
      sexeEnfant: "",
      poidsEnfant: "",
      tailleEnfant: "",
      ModaleArchivage: false,
      ModaleSuppresion: false,
      ModalePhoto: false,
      showModalCancel: false,
      showModalConfirm: false,
      etatCompte: "",
      lienPhoto: null,
      newHoraires: {
        MONDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH:mm"),
          horaireFin: moment().format("HH:mm"),
          nameOfDay: this.props.t('days.monday'),
        },
        TUESDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH:mm"),
          horaireFin: moment().format("HH:mm"),
          nameOfDay: this.props.t('days.tuesday'),
        },
        WEDNESDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH:mm"),
          horaireFin: moment().format("HH:mm"),
          nameOfDay: this.props.t('days.wednesday'),
        },
        THURSDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH:mm"),
          horaireFin: moment().format("HH:mm"),
          nameOfDay: this.props.t('days.thursday'),
        },
        FRIDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH:mm"),
          horaireFin: moment().format("HH:mm"),
          nameOfDay: this.props.t('days.friday'),
        },
        SATURDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH:mm"),
          horaireFin: moment().format("HH:mm"),
          nameOfDay: this.props.t('days.saturday'),
        },
        SUNDAY: {
          ouvert: false,
          horaireDebut: null,
          horaireFin: null,
          nameOfDay: this.props.t('days.sunday'),
        },
      },
    });
  };
  handleChangeBiberon = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
      [name]: "",
    });
    this.setState({
      biberonActif: !this.state.biberonActif,
      formErrors: fieldValidationErrors,
    });
  };
  handleChangeMarche = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    this.setState({ marcheActif: !this.state.marcheActif });
  };
  //Render for the Date time picker
  renderInput = (props) => (
    <div className="form-group">
      <input
        readOnly
        className="form-control ipt-id-naissance"
        type="text"
        onClick={props.onClick}
        id={props.id}
        value={props.textLabel + props.value}
        {...props.inputProps}
      />
    </div>
  );
  //  Funcion validation email
  validateField(name, value, index) {
    let fieldValidationErrors = this.state.formErrors;
    let emailValid = this.state.emailValid;
    let numeroTelValid = this.state.numeroTelValid;
    fieldValidationErrors.index = index;
    switch (name) {
      case "email":
        emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        fieldValidationErrors.email = emailValid ? "" : " est invalide";
        break;
      case "numeroTel":
        numeroTelValid = value.match(/^((\+)33|033|0)[1-9](\d{2}){4}$/g);
        fieldValidationErrors.numeroTel = numeroTelValid ? "" : " est invalide";
        break;
    }
    let newObj = {
      ...this.state.formErrors,
      [`${name}${index}`]: fieldValidationErrors[name],
    };
    this.setState(
      {
        formErrors: newObj,
        emailValid: emailValid,
        numeroTelValid: numeroTelValid,
      },
      this.validateForm
    );
  }
  //  Validation fomr for email
  validateForm() {
    this.setState({
      formValid: this.state.emailValid && this.state.numeroTelValid,
    });
  }
  //Error class validation
  errorClass(error) {
    return _.isEmpty(error) ? "" : "error-mess";
  }
  // Function Nom parent
  onChangeNomParent = (event, index) => {
    let value = event.target.value.split(" ");
    let parentNom =
      value.slice(1).join(" ") && value.slice(1).join(" ") !== " "
        ? value.slice(1).join(" ")
        : "";
    let parentPrenom = value[0] ? value[0] : "";

    let newChangedList = this.state.parents.map((p, i) =>
      index === i
        ? {
            ...p,
            noTouch: false,
            PrenomNom: event.target.value,
            nom: toUpperCaseFirst(parentNom),
            prenom: toUpperCaseFirst(parentPrenom),
          }
        : p
    );
    let name = event.target.name + index;
    let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
      [name]: "",
    });
    this.setState({
      parents: newChangedList,
      formErrors: fieldValidationErrors,
    });
  };
  // Function Change Adresse
  onChangeAdresse = (event, index) => {
    let value = event.target.value;
    let name = event.target.name;
    let newChangedList = this.state.parents.map((p, i) =>
      index === i
        ? { ...p, adresse: Object.assign({}, p.adresse, { [name]: value }) }
        : p
    );
    this.setState({ parents: newChangedList });
  };

  // HandleChange multiple
  handleChangeMulitple(event, id, index) {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;
    let newChangedList = this.state.parents.map((p, i) =>
      index === i ? { ...p, noTouch: false, [name]: event.target.value } : p
    );
    this.setState({ parents: newChangedList, [name]: value }, () => {
      this.validateField(name, value, index);
    });
  }
  // Function change Nom Tierce
  onChangeNomTierce = (event, id) => {
    let value = event.target.value.split(" ");
    let tierceNom =
      value.slice(1).join(" ") && value.slice(1).join(" ") !== " "
        ? value.slice(1).join(" ")
        : "";
    let tiercePrenom = value[0];

    let name = event.target.name;
    let nameP = "PrenomNomTierce" + id;
    let formErrors = Object.assign({}, this.state.formErrors, { [nameP]: "" });
    let newChangedList = this.state.tierces.map((p, index) =>
      index === id
        ? {
            ...p,
            PrenomNomTierce: event.target.value,
            nom: toUpperCaseFirst(tierceNom),
            prenom: toUpperCaseFirst(tiercePrenom),
          }
        : p
    );
    this.setState({ tierces: newChangedList, formErrors: formErrors });
  };
  // Function change Nom Enfant
  onChangeEnfant = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
      [name]: "",
    });
    this.setState({ nomPrenom: value, formErrors: fieldValidationErrors });
  };
  // Function change dateNaissance et dateInscription
  handleChangeNaissance = (date) => {
    this.setState({
      dateNaissance: date,
    });
  };
  handleChangeAdmission = (date) => {
    this.setState({
      dateAcceptation: date,
    });
  };
  handleChange = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
      [name]: "",
    });
    if (name === "biberonFrequence") {
      fieldValidationErrors = Object.assign({}, this.state.formErrors, {
        ["biberonActif"]: "",
      });
    }
    this.setState({ [name]: value, formErrors: fieldValidationErrors });
  };
  // Function handlechange Tierce

  handleChangeMulitpleTierces(event, id) {
    let name = event.target.name;
    let nameP = "PrenomNomTierce" + id;
    let nameTel = "numeroTelT" + id;
    let formErrors = Object.assign({}, this.state.formErrors, {
      [nameTel]: "",
    });
    let newChangedListTierces = this.state.tierces.map((p, index) =>
      index === id ? { ...p, [name]: event.target.value } : p
    );
    this.setState({ tierces: newChangedListTierces, formErrors: formErrors });
  }
  // Function show plus de Tierce
  showAddTierce() {
    if (this.state.newTierce.PrenomNomTierce) {
      let nomParent = this.state.newTierce.PrenomNomTierce.split(" ");
      let newTierce = this.state.newTierce;
      newTierce.nom =
        nomParent.slice(1).join(" ") && nomParent.slice(1).join(" ") !== " "
          ? nomParent.slice(1).join(" ")
          : "";
      newTierce.prenom = nomParent[0] ? nomParent[0] : "";
      let name = "PrenomNomTierceN";
      let nameTel = "numeroTelN";
      let validNom = newTierce.nom ? "" : this.props.t('validation.field_required_short');
      let validPrenom = newTierce.prenom ? "" : this.props.t('validation.field_required_short');
      let numeroTelValid = newTierce.numeroTel.match(
        /^((\+)33|033|0)[1-9](\d{2}){4}$/g
      );
      let numeroTel =
        newTierce.numeroTel && numeroTelValid
          ? ""
          : newTierce.numeroTel && !numeroTelValid
          ? this.props.t('validation.phone_invalid_short')
          : this.props.t('validation.field_required_alt');
      let formValid =
        _.isEmpty(validNom) && _.isEmpty(validPrenom) && _.isEmpty(numeroTel);
      let nomPrenom = validNom || validPrenom;
      if (formValid) {
        let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
          [name]: "",
          [nameTel]: "",
        });
        this.setState((prevState) => ({
          formErrors: fieldValidationErrors,
          tierces: [...prevState.tierces, newTierce],
          showTierce: true,
          newTierce: {
            PrenomNomTierce: "",
            numeroTel: "",
            nom: "",
            prenom: "",
            lienDeParente: "Ami",
          },
        }));
      } else {
        let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
          [name]: nomPrenom,
          [nameTel]: numeroTel,
        });
        this.setState({ formErrors: fieldValidationErrors });
      }
    }
  }
  // Function add Tierce
  onChangeAddTierce = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    let nameP = "PrenomNomTierceN";
    let nameTel = "numeroTelN";
    let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
      [nameP]: "",
      [nameTel]: "",
    });
    this.setState((prevState) => ({
      formErrors: fieldValidationErrors,
      newTierce: { ...prevState.newTierce, [name]: value },
    }));
  };
  // delete Tierce
  deleteTierce = (event, id) => {
    let newArray = [];
    newArray = this.state.tierces.filter((element, index) => id !== index);
    this.setState((prevState) => ({
      tierces: [...newArray],
    }));
  };
  toggle() {
    this.props.toggle();
  }
  //Function to handle the informations in the horaire Modal Dialog
  handleChangeHoraire(name, day) {
    let arrayOfDays = [];

    let horaires = this.state.newHoraires;
    let newDay = day.ouvert
      ? Object.assign(day, { ouvert: false })
      : Object.assign(day, { ouvert: true });
    horaires[name] = Object.assign({}, newDay);
    this.setState({ newHoraires: Object.assign({}, horaires) });
  }
  // Function change dateNaissance et dateInscription
  handleChangeNaissance = (date) => {
    this.setState({
      dateNaissance: date,
    });
  };
  handleChangeAdmission = (date) => {
    this.setState({
      dateAcceptation: date,
    });
  };

  //Function to handle the informations in the horaire Modal Dialog
  handleChangeHoraire(name, day) {
    let arrayOfDays = [];

    let horaires = this.state.newHoraires;
    let newDay = day.ouvert
      ? Object.assign(day, { ouvert: false })
      : Object.assign(day, { ouvert: true });
    horaires[name] = Object.assign({}, newDay);
    this.setState({ newHoraires: Object.assign({}, horaires) });
  }
  // Function show plus de Tierce
  showModalHoraires() {
    this.setState({ ModalHoraires: true });
  }
  onSubmitModal() {
    let numJour = Array.from(_.values(this.state.newHoraires)).reduce(
      (accu, element) => {
        return element.ouvert ? accu + 1 : accu;
      },
      0
    );
    let horaireDebut = moment(this.state.horaireDebut).format("HH[h]mm");
    let horaireFin = moment(this.state.horaireFin).format("HH[h]mm");
    let newhoraire =
      horaireDebut.charAt(0) === "0"
        ? horaireDebut.slice(1) + "-" + horaireFin
        : horaireDebut + "-" + horaireFin;
    Object.keys(this.state.newHoraires).forEach((nameOfDay) => {
      this.state.newHoraires[nameOfDay] = Object.assign(
        {},
        this.state.newHoraires[nameOfDay],
        {
          horaireDebut: moment(this.state.horaireDebut, "HH[h]mm").format(
            "HH:mm:ss"
          ),
          horaireFin: moment(this.state.horaireFin, "HH[h]mm").format(
            "HH:mm:ss"
          ),
        }
      );
    });
    let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
      ["numJour"]: "",
    });
    this.setState({
      ModalHoraires: false,
      numJour: numJour,
      horaire: newhoraire,
      formErrors: fieldValidationErrors,
    });
  }
  onClose() {
    this.setState({ ModalHoraires: false });
  }
  handleChangeTimeEnd(date) {
    this.setState(
      {
        horaireFin: moment(date),
      },
      () => {
        let horaireDebut = moment(this.state.horaireDebut).format("HH[h]mm");
        let horaireFin = moment(this.state.horaireFin).format("HH[h]mm");
        let horaire =
          horaireDebut.charAt(0) === "0"
            ? horaireDebut.slice(1) + "-" + horaireFin
            : horaireDebut + "-" + horaireFin;
        let newHoraires = this.state.newHoraires;
        Object.keys(newHoraires).forEach((nameOfDay) => {
          newHoraires[nameOfDay] = Object.assign({}, newHoraires[nameOfDay], {
            horaireFin: moment(this.state.horaireFin, "HH[h]mm").format(
              "HH:mm:ss"
            ),
          });
        });
        this.setState({ horaire: horaire, newHoraires: newHoraires });
      }
    );
  }
  handleChangeTimeStart(date) {
    this.setState(
      {
        horaireDebut: moment(date),
      },
      () => {
        let horaireDebut = moment(this.state.horaireDebut).format("HH[h]mm");
        let horaireFin = moment(this.state.horaireFin).format("HH[h]mm");
        let horaire =
          horaireDebut.charAt(0) === "0"
            ? horaireDebut.slice(1) + "-" + horaireFin
            : horaireDebut + "-" + horaireFin;
        let newHoraires = this.state.newHoraires;
        Object.keys(newHoraires).forEach((nameOfDay) => {
          newHoraires[nameOfDay] = Object.assign({}, newHoraires[nameOfDay], {
            horaireDebut: moment(this.state.horaireDebut, "HH[h]mm").format(
              "HH:mm:ss"
            ),
          });
        });

        this.setState({ horaire: horaire, newHoraires: newHoraires });
      }
    );
  }
  validateSubmit() {
    this.closeModalConfirm();
    let dataEnfant;
    let dataParents;
    let dataTierces = [];
    let formErrors = this.state.formErrors;
    let allValid = [];

    //Control kids infos
    let nomprenomenfant = this.state.nomPrenom.split(" ");
    let validNomE = !_.isEmpty(nomprenomenfant[1]) ? "" : this.props.t('validation.field_required_short');
    let validPrenomE = !_.isEmpty(nomprenomenfant[0]) ? "" : this.props.t('validation.field_required_short');
    let validSexe = this.state.sexeEnfant ? "" : this.props.t('validation.field_required_short');
    let validPoids =
      this.state.poidsEnfant && this.state.poidsEnfant >= 0
        ? ""
        : this.state.poidsEnfant && this.state.poidsEnfant < 0
        ? this.props.t('validation.field_cannot_be_negative')
        : this.props.t('validation.field_required_short');
    let validTaille =
      this.state.tailleEnfant && this.state.tailleEnfant >= 0
        ? ""
        : this.state.tailleEnfant && this.state.tailleEnfant < 0
        ? this.props.t('validation.field_cannot_be_negative')
        : this.props.t('validation.field_required_short');
    let validDateNaissance = this.state.dateNaissance
      ? ""
      : this.props.t('validation.field_required_short');
    let validDateAccept = this.state.dateAcceptation
      ? ""
      : this.props.t('validation.field_required_short');
    let validNumJour = this.state.numJour > 0 ? "" : this.props.t('validation.field_required_short');
    let validBiberon =
      this.state.biberonActif === false
        ? ""
        : this.state.biberonFrequence && this.state.biberonFrequence >= 0
        ? ""
        : this.state.biberonFrequence && this.state.biberonFrequence < 0
        ? this.props.t('validation.field_cannot_be_negative')
        : this.props.t('validation.field_required_short');
    let nomPrenom = validNomE || validPrenomE;
    let cleanHorraire = this.state.newHoraires;
    Object.keys(this.state.newHoraires).forEach((nameOfDay) => {
      delete cleanHorraire[nameOfDay].nameOfDay;
      delete cleanHorraire[nameOfDay].numDay;
    });
    let formValidEnfant =
      _.isEmpty(validNomE) &&
      _.isEmpty(validPrenomE) &&
      _.isEmpty(validTaille) &&
      _.isEmpty(validPoids) &&
      _.isEmpty(validSexe) &&
      _.isEmpty(validDateNaissance) &&
      _.isEmpty(validDateAccept) &&
      _.isEmpty(validBiberon) &&
      _.isEmpty(validNumJour);

    if (formValidEnfant) {
      if (this.state.biberonActif) {
        dataEnfant = {
          biberonFrequence: this.state.biberonFrequence,
          dateAcceptation: moment(this.state.dateAcceptation).format(
            "YYYY-MM-DD"
          ),
          dateNaissance: moment(this.state.dateNaissance).format("YYYY-MM-DD"),
          horairesDetails: { horaires: cleanHorraire },
          idPhoto: this.state.fileId,
          nom: nomprenomenfant[1],
          poid: this.state.poidsEnfant,
          prenom: nomprenomenfant[0],
          rampeur: !this.state.marcheActif,
          sexe: this.state.sexeEnfant,
          taille: this.state.tailleEnfant,
          etatDiversification: "ENCOURS",
        };
        allValid.push(true);
        let formErrors = Object.assign({}, formErrors, {
          nomPrenom: "",
          sexeEnfant: "",
          poidsEnfant: "",
          tailleEnfant: "",
          dateNaissance: "",
          dateAcceptation: "",
          biberonActif: "",
          numJour: "",
        });
      } else {
        dataEnfant = {
          rampeur: !this.state.marcheActif,
          biberonFrequence: null,
          dateAcceptation: moment(this.state.dateAcceptation).format(
            "YYYY-MM-DD"
          ),
          dateNaissance: moment(this.state.dateNaissance).format("YYYY-MM-DD"),
          horairesDetails: { horaires: cleanHorraire },
          idPhoto: this.state.fileId,
          nom: nomprenomenfant[1],
          poid: this.state.poidsEnfant,
          prenom: nomprenomenfant[0],
          sexe: this.state.sexeEnfant,
          taille: this.state.tailleEnfant,
          etatDiversification: "ENCOURS",
        };
        allValid.push(true);
        formErrors = Object.assign({}, formErrors, {
          nomPrenom: "",
          sexeEnfant: "",
          poidsEnfant: "",
          tailleEnfant: "",
          dateNaissance: "",
          dateAcceptation: "",
          biberonActif: "",
          numJour: "",
        });
      }
    } else {
      allValid.push(false);

      formErrors = Object.assign({}, formErrors, {
        nomPrenom: nomPrenom,
        sexeEnfant: validSexe,
        poidsEnfant: validPoids,
        tailleEnfant: validTaille,
        dateNaissance: validDateNaissance,
        dateAcceptation: validDateAccept,
        biberonActif: validBiberon,
        numJour: validNumJour,
      });
    }

    //Start of Identite code Parents

    let validNom0 =
      !_.isEmpty(this.state.parents[0].nom) && this.state.parents[0].nom !== " "
        ? ""
        : this.props.t('validation.field_required_short');
    let validPrenom0 =
      !_.isEmpty(this.state.parents[0].prenom) &&
      this.state.parents[0].prenom !== " "
        ? ""
        : this.props.t('validation.field_required_short');
    let validEmail = !_.isEmpty(this.state.parents[0].email)
      ? formErrors.email0
      : this.props.t('validation.field_required_short');
    let validTel = !_.isEmpty(this.state.parents[0].numeroTel)
      ? formErrors.numeroTel0
      : this.props.t('validation.field_required_short');
    let validNom1 =
      !_.isEmpty(this.state.parents[1].nom) && this.state.parents[1].nom !== " "
        ? ""
        : this.props.t('validation.field_required_short');
    let validPrenom1 =
      !_.isEmpty(this.state.parents[1].prenom) &&
      this.state.parents[1].prenom !== " "
        ? ""
        : this.props.t('validation.field_required_short');
    let validEmail1 = !_.isEmpty(this.state.parents[1].email)
      ? formErrors.email1
      : this.props.t('validation.field_required_short');
    let validTel1 = !_.isEmpty(this.state.parents[1].numeroTel)
      ? formErrors.numeroTel1
      : this.props.t('validation.field_required_short');
    let formValid0 =
      _.isEmpty(validNom0) &&
      _.isEmpty(validPrenom0) &&
      _.isEmpty(validEmail) &&
      _.isEmpty(validTel);

    let nomPrenom0 = validNom0 || validPrenom0;
    let nomPrenom1 = validNom1 || validPrenom1;

    let emptyParent0 =
      _.isEmpty(this.state.parents[0].nom) &&
      _.isEmpty(this.state.parents[0].prenom) &&
      _.isEmpty(this.state.parents[0].email) &&
      _.isEmpty(this.state.parents[0].numeroTel);
    let emptyParent1 =
      _.isEmpty(this.state.parents[1].nom) &&
      _.isEmpty(this.state.parents[1].prenom) &&
      _.isEmpty(this.state.parents[1].email) &&
      _.isEmpty(this.state.parents[1].numeroTel);

    let formValid1 =
      _.isEmpty(validNom1) &&
      _.isEmpty(validPrenom1) &&
      _.isEmpty(validEmail1) &&
      _.isEmpty(validTel1);
    if (formValid0 && formValid1) {
      allValid.push(true);

      dataParents = {
        parents: [
          {
            adresse: {
              codePostal: this.state.parents[0].adresse.codePostal,
              pays: this.state.parents[0].adresse.pays,
              rue: this.state.parents[0].adresse.rue,
              ville: this.state.parents[0].adresse.ville,
            },
            email: this.state.parents[0].email,
            etatCompte: this.state.parents[0].etatCompte,
            id: this.state.parents[0].id,
            nom: this.state.parents[0].nom,
            numeroTel: this.state.parents[0].numeroTel,
            prenom: this.state.parents[0].prenom,
            situation: this.state.parents[0].situation,
          },
          {
            adresse: {
              codePostal: this.state.parents[1].adresse.codePostal,
              pays: this.state.parents[1].adresse.pays,
              rue: this.state.parents[1].adresse.rue,
              ville: this.state.parents[1].adresse.ville,
            },
            email: this.state.parents[1].email,
            etatCompte: this.state.parents[1].etatCompte,
            id: this.state.parents[1].id,
            nom: this.state.parents[1].nom,
            numeroTel: this.state.parents[1].numeroTel,
            prenom: this.state.parents[1].prenom,
            situation: this.state.parents[1].situation,
          },
        ],
      };

      formErrors = Object.assign({}, formErrors, {
        email0: "",
        numeroTel0: "",
        nom0: "",
        prenom0: "",
        nomPrenom0: "",
        nomPrenom1: "",
        email1: "",
        numeroTel1: "",
        nom1: "",
        prenom1: "",
      });
    } else {
      if (!emptyParent0 && formValid0 && emptyParent1) {
        dataParents = {
          parents: [
            {
              adresse: {
                codePostal: this.state.parents[0].adresse.codePostal,
                pays: this.state.parents[0].adresse.pays,
                rue: this.state.parents[0].adresse.rue,
                ville: this.state.parents[0].adresse.ville,
              },
              email: this.state.parents[0].email,
              etatCompte: this.state.parents[0].etatCompte,
              id: this.state.parents[0].id,
              nom: this.state.parents[0].nom,
              numeroTel: this.state.parents[0].numeroTel,
              prenom: this.state.parents[0].prenom,
              situation: this.state.parents[0].situation,
            },
          ],
        };
        allValid.push(true);

        formErrors = Object.assign({}, formErrors, {
          email0: "",
          numeroTel0: "",
          nom0: "",
          prenom0: "",
          nomPrenom0: "",
          nomPrenom1: "",
          email1: "",
          numeroTel1: "",
          nom1: "",
          prenom1: "",
        });
      } else if (emptyParent0 && formValid1 && !emptyParent1) {
        dataParents = {
          parents: [
            {
              adresse: {
                codePostal: this.state.parents[1].adresse.codePostal,
                pays: this.state.parents[1].adresse.pays,
                rue: this.state.parents[1].adresse.rue,
                ville: this.state.parents[1].adresse.ville,
              },
              email: this.state.parents[1].email,
              etatCompte: this.state.parents[1].etatCompte,
              id: this.state.parents[1].id,
              nom: this.state.parents[1].nom,
              numeroTel: this.state.parents[1].numeroTel,
              prenom: this.state.parents[1].prenom,
              situation: this.state.parents[1].situation,
            },
          ],
        };
        allValid.push(true);

        // this.props.updateIdentiteSimpleInfoParent(localStorage.getItem('token'), this.props.kidItem.id, dataParents)
        formErrors = Object.assign({}, formErrors, {
          email0: "",
          numeroTel0: "",
          nom0: "",
          prenom0: "",
          nomPrenom0: "",
          nomPrenom1: "",
          email1: "",
          numeroTel1: "",
          nom1: "",
          prenom1: "",
        });
        // this.setState({ formErrors: formErrors })
      } else {
        allValid.push(false);

        if (emptyParent0) {
          formErrors = Object.assign({}, formErrors, {
            email0: validEmail,
            numeroTel0: validTel,
            nom0: validNom0,
            prenom0: validPrenom0,
            nomPrenom0: nomPrenom0,
          });
          // this.setState({ formErrors: formErrors })
        } else if (!emptyParent0 && emptyParent1) {
          formErrors = Object.assign({}, formErrors, {
            email0: validEmail,
            numeroTel0: validTel,
            nom0: validNom0,
            prenom0: validPrenom0,
            nomPrenom0: nomPrenom0,
          });
          // this.setState({ formErrors: formErrors })
        } else if (emptyParent0 && !emptyParent1) {
          formErrors = Object.assign({}, formErrors, {
            nomPrenom1: nomPrenom1,
            email1: validEmail1,
            numeroTel1: validTel1,
            nom1: validNom1,
            prenom1: validPrenom1,
          });
          // this.setState({ formErrors: formErrors })
        } else {
          formErrors = Object.assign({}, formErrors, {
            email0: validEmail,
            numeroTel0: validTel,
            nom0: validNom0,
            prenom0: validPrenom0,
            nomPrenom0: nomPrenom0,
            nomPrenom1: nomPrenom1,
            email1: validEmail1,
            numeroTel1: validTel1,
            nom1: validNom1,
            prenom1: validPrenom1,
          });
          // this.setState({ formErrors: formErrors })
        }
      }
    }

    //Code for the Tierces

    let arrayValid = [];
    this.state.tierces.forEach((element, index) => {
      let name = "PrenomNomTierce" + index;
      let nameTel = "numeroTelT" + index;
      let validNomT = element.nom ? "" : this.props.t('validation.field_required_short');
      let validPrenomT = element.prenom ? "" : this.props.t('validation.field_required_short');
      let numeroTelValidT = element.numeroTel.match(
        /^((\+)33|033|0)[1-9](\d{2}){4}$/g
      );
      let numeroTelT =
        element.numeroTel && numeroTelValidT
          ? ""
          : element.numeroTel && !numeroTelValidT
          ? this.props.t('validation.phone_invalid_short')
          : this.props.t('validation.field_required_alt');
      let formValid =
        _.isEmpty(validNomT) &&
        _.isEmpty(validPrenomT) &&
        _.isEmpty(numeroTelT);
      let elementEmpty =
        _.isEmpty(element.nom) &&
        _.isEmpty(element.prenom) &&
        _.isEmpty(element.numeroTel);
      arrayValid.push(elementEmpty || formValid);
      let nomPrenomT = validNomT || validPrenomT;
      if (formValid && !elementEmpty) {
        if (_.isEmpty(element.id)) {
          dataTierces.push({
            lienDeParente: element.lienDeParente,
            nom: element.nom,
            numeroTel: element.numeroTel,
            prenom: element.prenom,
          });
        } else {
          dataTierces.push({
            id: element.id,
            lienDeParente: element.lienDeParente,
            nom: element.nom,
            numeroTel: element.numeroTel,
            prenom: element.prenom,
          });
        }
      } else if (!elementEmpty && !formValid) {
        allValid.push(false);

        formErrors = Object.assign({}, formErrors, {
          [name]: nomPrenomT,
          [nameTel]: numeroTelT,
        });
        // this.setState({ formErrors: formErrors })
      } else {
        formErrors = Object.assign({}, formErrors, {
          [name]: "",
          [nameTel]: "",
        });
        // this.setState({ formErrors: formErrors })
      }
    });
    if (arrayValid.every((element) => element) && !_.isEmpty(dataTierces)) {
      // this.props.updateIdentiteSimpleInfoTierce(localStorage.getItem('token'), this.props.kidItem.id, data)
      allValid.push(true);

      dataTierces.forEach((element, index) => {
        let name = "PrenomNomTierce" + index;
        let nameTel = "numeroTelT" + index;
        formErrors = Object.assign({}, formErrors, {
          [name]: "",
          [nameTel]: "",
        });
      });
      formErrors = Object.assign({}, formErrors, {
        PrenomNomTierceN: "",
        numeroTelN: "",
      });
      // this.setState({ formErrors: formErrors })
    } else if (_.isEmpty(dataTierces)) {
      formErrors = Object.assign({}, formErrors, {
        PrenomNomTierceN: "",
        numeroTelN: "",
      });
      dataTierces = [];
      allValid.push(true);

      // this.props.updateIdentiteSimpleInfoTierce(localStorage.getItem('token'), this.props.kidItem.id, data)
    }
    if (allValid.every((element) => element)) {
      let cleanParents = [];
      _.isEmpty(dataParents.parents)
        ? (cleanParents = null)
        : dataParents.parents.forEach((element) => {
            delete element.PrenomNom;
            delete element.id;
            delete element.fullAdress;
            delete element.etatCompte;
            if (
              element.nom &&
              element.prenom &&
              element.numeroTel &&
              element.email
            ) {
              cleanParents.push({
                couplageActif: "true",
                parent: { ...element },
              });
            }
          });
      let data = {
        ...dataEnfant,
        liensParente: cleanParents,
        tierceAutorises: dataTierces,
      };
      this.setState({ dataSubmit: data, showModalConfirm: true });
      // this.props.postEnfantSimple(localStorage.getItem('token'), data)
    }

    this.setState({ formErrors: formErrors });
  }
  renderContent = () => {
    const classes = makeStyles((theme) => ({
      root: {
        "& > *": {
          margin: theme.spacing(1),
        },
      },
      input: {
        display: "none",
      },
    }));
    if (isMobile) {
      return (
        <div className={classes.root}>
          <input
            className={classes.input}
            id="contained-button-file"
            type="file"
            style={{ display: "none" }}
            onChange={this.onSelectFile}
            accept="image/png,image/bmp,image/jpeg"
          />

          <div className="input-file-style mr-3">
            <label
              htmlFor="contained-button-file"
              className="btn-photo btn-gradient"
            >
              <img src={srcIconPhoto} className="img-fluid" alt="" />{" "}
            </label>
          </div>
        </div>
      );
    }
    return (
      <button
        type="bouton"
        className="btn-photo btn-gradient"
        data-toggle="modal"
        data-target="#modalPhoto"
        onClick={(e) => this.showModalPhoto(e)}
      >
        <img src={srcIconPhoto} className="img-fluid" alt="" />
      </button>
    );
  };

  render() {
    var divStyle = (lienPhoto) => ({
      backgroundImage: "url(" + lienPhoto + ")",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    });

    return (
      <div className="content-fiche">
        <div className="tab-content p-0" id="myTabContent">
          <div
            className="tab-pane fade active show"
            id="identite-pane"
            role="tabpanel"
            aria-labelledby="identite-tab"
          >
            <div className="content p-0">
              <p className="small-bottom-space"></p>
              <section className="content-section">
                <h2>{this.props.t('creche_form.child_info')}</h2>
                <div className="row">
                  <div className="col-md-5">
                    <div
                      className={`form-group ${this.errorClass(
                        this.state.formErrors[`nomPrenom`]
                      )}`}
                    >
                      <input
                        type="text"
                        className="form-control ipt-id-nom"
                        name="nomPrenom"
                        placeholder={this.props.t('fiche_enfant.prenom_nom')}
                        onChange={this.onChangeEnfant}
                        value={this.state.nomPrenom}
                      />
                      {(() => {
                        if (!_.isEmpty(this.state.formErrors["nomPrenom"])) {
                          return (
                            <p>
                              {this.props.t('creche_form.name_and_firstname')} {this.state.formErrors["nomPrenom"]}
                            </p>
                          );
                        } else {
                          return "";
                        }
                      })()}
                    </div>
                    {/* Choix date NAISSANCE  */}
                    <div className="form-group">
                      <ThemeProvider theme={materialTheme}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <DatePicker
                            autoOk
                            ampm={false}
                            value={this.state.dateNaissance}
                            onChange={this.handleChangeNaissance}
                            format={" DD MMM YYYY"}
                            TextFieldComponent={this.renderInput}
                            textLabel={this.props.t('creche_form.born_on')}
                          />
                        </MuiPickersUtilsProvider>
                      </ThemeProvider>
                    </div>
                    <div
                      className={`form-group ${this.errorClass(
                        this.state.formErrors[`sexeEnfant`]
                      )}`}
                    >
                      <select
                        onChange={this.handleChange}
                        value={this.state.sexeEnfant}
                        className="form-control ipt-id-heures"
                        name="sexeEnfant"
                      >
                        <option
                          value=""
                          disabled
                          hidden
                          className="form-control ipt-id-heures"
                        >
                          {this.props.t('creche_form.sex')}
                        </option>
                        <option defaultValue value="MALE">
                          {this.props.t('creche_form.boy')}
                        </option>
                        <option value="FEMELLE">{this.props.t('creche_form.girl')}</option>
                      </select>
                      {(() => {
                        if (!_.isEmpty(this.state.formErrors["sexeEnfant"])) {
                          return <p>{this.state.formErrors["sexeEnfant"]}</p>;
                        } else {
                          return "";
                        }
                      })()}
                    </div>
                    <div
                      className={`form-group ${this.errorClass(
                        this.state.formErrors[`poidsEnfant`]
                      )}`}
                    >
                      <input
                        type="number"
                        className="form-control ipt-id-heures"
                        name="poidsEnfant"
                        placeholder={this.props.t('creche_form.weight')}
                        onChange={this.handleChange}
                        value={this.state.poidsEnfant}
                      />
                      {(() => {
                        if (!_.isEmpty(this.state.formErrors["poidsEnfant"])) {
                          return <p>{this.state.formErrors["poidsEnfant"]}</p>;
                        } else {
                          return "";
                        }
                      })()}
                    </div>
                    <div
                      className={`form-group ${this.errorClass(
                        this.state.formErrors[`tailleEnfant`]
                      )}`}
                    >
                      <input
                        type="number"
                        className="form-control ipt-id-heures"
                        name="tailleEnfant"
                        placeholder={this.props.t('creche_form.height')}
                        onChange={this.handleChange}
                        value={this.state.tailleEnfant}
                      />
                      {(() => {
                        if (!_.isEmpty(this.state.formErrors["tailleEnfant"])) {
                          return <p>{this.state.formErrors["tailleEnfant"]}</p>;
                        } else {
                          return "";
                        }
                      })()}
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="form-group">
                      <ThemeProvider theme={materialTheme}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <DatePicker
                            autoOk
                            ampm={false}
                            value={this.state.dateAcceptation}
                            onChange={this.handleChangeAdmission}
                            format={" DD MMM YYYY"}
                            TextFieldComponent={this.renderInput}
                            textLabel={this.props.t('creche_form.admitted_on')}
                          />
                        </MuiPickersUtilsProvider>
                      </ThemeProvider>
                    </div>
                    <div
                      className="row align-items-center row-horaires"
                      data-toggle="modal"
                      data-target="#modalHoraires"
                    >
                      <div className="col-md-6 pr-0">
                        <div
                          className={`form-group ${this.errorClass(
                            this.state.formErrors[`numJour`]
                          )}`}
                        >
                          <input
                            type="text"
                            className="form-control ipt-id-jours"
                            name="numJour"
                            placeholder={this.props.t('creche_form.days_per_week')}
                            onClick={this.showModalHoraires}
                            readOnly
                            value={this.state.numJour + " " + this.props.t('creche_form.days')}
                          />
                          {(() => {
                            if (!_.isEmpty(this.state.formErrors["numJour"])) {
                              return <p>{this.state.formErrors["numJour"]}</p>;
                            } else {
                              return "";
                            }
                          })()}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control ipt-id-heures"
                            name="horaire"
                            placeholder={this.props.t('creche_form.schedule')}
                            onClick={this.showModalHoraires}
                            readOnly
                            value={this.state.horaire}
                          />
                          {this.state.ModalHoraires ? (
                            <ModalHoraires
                              handleChangeTimeEnd={this.handleChangeTimeEnd}
                              handleChangeTimeStart={this.handleChangeTimeStart}
                              horaireDebut={this.state.horaireDebut}
                              horaireFin={this.state.horaireFin}
                              horaires={this.state.newHoraires}
                              handleChange={this.handleChangeHoraire}
                              onClose={this.onClose}
                              onSubmitModal={this.onSubmitModal}
                              title={this.props.t('creche.presence_schedule')}
                            />
                          ) : (
                            ""
                          )}
                          {(() => {
                            if (!_.isEmpty(this.state.formErrors["numJour"])) {
                              return (
                                <p
                                  style={{
                                    marginTop: "45px",
                                  }}
                                >
                                  {" "}
                                </p>
                              );
                            } else {
                              return "";
                            }
                          })()}
                        </div>
                      </div>
                    </div>
                    <ul className="row list-enfants list-sans-avatar">
                      <li className="col-md-7">
                        <input
                          type="checkbox"
                          id="marche"
                          value="marche"
                          onChange={this.handleChangeMarche}
                          checked={this.state.marcheActif}
                        />
                        <label
                          className="rounded15 box-shadow"
                          htmlFor="marche"
                          name="marcheActif"
                          checked={this.state.marcheActif}
                        >
                          <span className="avatar"></span>
                          <span className="name">{this.props.t('creche_form.walks')}</span>
                        </label>
                      </li>
                    </ul>
                    <ul className="row list-enfants list-sans-avatar">
                      <li className="col-md-7">
                        <input
                          type="checkbox"
                          id="biberon"
                          value="biberon"
                          onChange={this.handleChangeBiberon}
                          checked={this.state.biberonActif}
                        />
                        <label
                          className="rounded15 box-shadow"
                          htmlFor="biberon"
                          name="biberonActif"
                          checked={this.state.biberonActif}
                        >
                          <span className="avatar"></span>
                          <span className="name">{this.props.t('creche_form.bottle_fed')}</span>
                        </label>
                      </li>
                    </ul>
                    {this.state.biberonActif ? (
                      <div
                        className={`form-group ${this.errorClass(
                          this.state.formErrors[`biberonActif`]
                        )}`}
                      >
                        <input
                          type="number"
                          className="form-control ipt-id-heures"
                          placeholder={this.props.t('creche_form.bottle_hours')}
                          name="biberonFrequence"
                          value={this.state.biberonFrequence}
                          onChange={this.handleChange}
                        />
                        {(() => {
                          if (
                            !_.isEmpty(this.state.formErrors["biberonActif"])
                          ) {
                            return (
                              <p>{this.state.formErrors["biberonActif"]}</p>
                            );
                          } else {
                            return "";
                          }
                        })()}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="col-md-2">
                    <div
                      className="photo-enfant"
                      style={
                        this.state.showPhoto == null
                          ? divStyle(this.state.lienPhoto)
                          : divStyle(
                              window.URL.createObjectURL(this.state.showPhoto)
                            )
                      }
                    >
                      {this.renderContent()}
                    </div>
                  </div>
                </div>
                <p className="bottom-space"></p>
              </section>

              {Array.from(this.state.parents, (parent, index) => (
                <section className="content-section" key={index}>
                  <h2>{this.props.t('creche_form.parent_info', { number: index + 1 })}</h2>
                  <div className="row align-items-stretch">
                    <div className="col-md-5">
                      <div
                        className={`form-group ${this.errorClass(
                          this.state.formErrors[`nomPrenom${index}`]
                        )}`}
                      >
                        <input
                          type="text"
                          className="form-control ipt-id-nom"
                          name="nomPrenom"
                          onChange={(e) => this.onChangeNomParent(e, index)}
                          placeholder={this.props.t('fiche_enfant.prenom_nom')}
                          value={parent.PrenomNom}
                        />
                        {Object.keys(this.state.formErrors).map(
                          (fieldName, i) => {
                            if (
                              !_.isEmpty(this.state.formErrors[fieldName]) &&
                              `nomPrenom${index}` === fieldName
                            ) {
                              return (
                                <p key={i}>
                                  {this.props.t('creche_form.name_and_firstname')}{" "}
                                  {this.state.formErrors[fieldName]}
                                </p>
                              );
                            } else {
                              return "";
                            }
                          }
                        )}
                      </div>
                      <div
                        className={`form-group ${this.errorClass(
                          this.state.formErrors[`numeroTel${index}`]
                        )}`}
                      >
                        <input
                          type="tel"
                          className="form-control ipt-id-tel"
                          name="numeroTel"
                          onChange={(e) =>
                            this.handleChangeMulitple(e, parent.id, index)
                          }
                          placeholder={this.props.t('creche_form.phone')}
                          value={parent.numeroTel}
                        />
                        {Object.keys(this.state.formErrors).map(
                          (fieldName, i) => {
                            if (
                              !_.isEmpty(this.state.formErrors[fieldName]) &&
                              `numeroTel${index}` === fieldName
                            ) {
                              return (
                                <p key={i}>
                                  {this.props.t('creche_form.phone')} {this.state.formErrors[fieldName]}
                                </p>
                              );
                            } else {
                              return "";
                            }
                          }
                        )}
                      </div>
                      <div
                        className={`form-group ${this.errorClass(
                          this.state.formErrors[`email${index}`]
                        )}`}
                      >
                        <input
                          type="email"
                          key={index}
                          required
                          className="form-control ipt-id-email"
                          name="email"
                          onChange={(e) =>
                            this.handleChangeMulitple(e, parent.id, index)
                          }
                          placeholder={this.props.t('staff_modal.email')}
                          value={parent.email}
                        />
                        {Object.keys(this.state.formErrors).map(
                          (fieldName, i) => {
                            if (
                              !_.isEmpty(this.state.formErrors[fieldName]) &&
                              `email${index}` === fieldName
                            ) {
                              return (
                                <p key={i}>
                                  {this.props.t('staff_modal.email')} {this.state.formErrors[fieldName]}
                                </p>
                              );
                            } else {
                              return "";
                            }
                          }
                        )}
                      </div>
                    </div>
                    <div className="col-md-5 ">
                      <div className="form-group">
                        <input
                          onChange={(e) => this.onChangeAdresse(e, index)}
                          value={parent.adresse.rue}
                          name="rue"
                          type="text"
                          id={"adresse-etablissement" + index}
                          placeholder={this.props.t('creche_form.address')}
                          className="form-control box-shadow custom-input ipt-id-adress2"
                        />
                      </div>
                      <div className="form-group">
                        <input
                          onChange={(e) => this.onChangeAdresse(e, index)}
                          value={parent.adresse.codePostal}
                          name="codePostal"
                          type="number"
                          id={"cp-etablissement" + index}
                          placeholder={this.props.t('creche_form.postal_code')}
                          className="form-control box-shadow custom-input ipt-id-adress2"
                        />
                      </div>
                      <div className="form-group">
                        <input
                          onChange={(e) => this.onChangeAdresse(e, index)}
                          value={parent.adresse.ville}
                          name="ville"
                          type="text"
                          id={"ville-etablissement" + index}
                          placeholder={this.props.t('creche_form.city')}
                          className="form-control box-shadow custom-input ipt-id-adress2"
                        />
                      </div>
                      <div className="form-group">
                        <input
                          onChange={(e) => this.onChangeAdresse(e, index)}
                          name="pays"
                          type="text"
                          id={"ville-etablissement" + index}
                          placeholder={this.props.t('creche_form.country')}
                          className="form-control box-shadow custom-input ipt-id-adress2"
                          value={parent.adresse.pays}
                        />
                      </div>
                    </div>
                  </div>
                  <p className="bottom-space"></p>
                </section>
              ))}
              <section className="content-section">
                <h2>{this.props.t('creche_form.authorized_tiers')}</h2>
                {Array.from(this.state.tierces, (tierce, index) => (
                  <div key={index} className="row align-items-center mb-3">
                    <div className="col-md-5">
                      <div
                        className={`form-group ${this.errorClass(
                          this.state.formErrors[`PrenomNomTierce${index}`]
                        )}`}
                      >
                        <input
                          type="text"
                          className="form-control ipt-id-nom"
                          name="PrenomNomTierce"
                          onChange={(e) => this.onChangeNomTierce(e, index)}
                          placeholder={this.props.t('identite.firstname_lastname')}
                          value={tierce.PrenomNomTierce}
                        />
                        {Object.keys(this.state.formErrors).map(
                          (fieldName, i) => {
                            if (
                              !_.isEmpty(this.state.formErrors[fieldName]) &&
                              `PrenomNomTierce${index}` === fieldName
                            ) {
                              return (
                                <p key={i}>
                                  {this.props.t('creche_form.name_and_firstname')}{" "}
                                  {this.state.formErrors[fieldName]}
                                </p>
                              );
                            } else if (
                              !_.isEmpty(this.state.formErrors[fieldName]) &&
                              `numeroTelT${index}` === fieldName
                            ) {
                              return (
                                <p
                                  key={i}
                                  style={{
                                    marginTop: "45px",
                                  }}
                                ></p>
                              );
                            } else {
                              return "";
                            }
                          }
                        )}
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div
                        className={`form-group ${this.errorClass(
                          this.state.formErrors[`numeroTelT${index}`]
                        )}`}
                      >
                        <input
                          type="text"
                          className="form-control ipt-id-tel"
                          name="numeroTel"
                          onChange={(e) =>
                            this.handleChangeMulitpleTierces(e, index)
                          }
                          placeholder="xx xx xx xx xx"
                          value={tierce.numeroTel}
                        />
                        {Object.keys(this.state.formErrors).map(
                          (fieldName, i) => {
                            if (
                              !_.isEmpty(this.state.formErrors[fieldName]) &&
                              `numeroTelT${index}` === fieldName
                            ) {
                              return (
                                <p key={i}>
                                  {" "}
                                  {this.state.formErrors[fieldName]}
                                </p>
                              );
                            } else if (
                              !_.isEmpty(this.state.formErrors[fieldName]) &&
                              `PrenomNomTierce${index}` === fieldName
                            ) {
                              return (
                                <p
                                  key={i}
                                  style={{
                                    marginTop: "45px",
                                  }}
                                ></p>
                              );
                            } else {
                              return "";
                            }
                          }
                        )}
                      </div>
                    </div>
                    <div className="col-md-2 d-flex align-items-center">
                      <button
                        type="button"
                        className="action-line delete"
                        onClick={(e) => this.deleteTierce(e, index)}
                      ></button>
                    </div>
                  </div>
                ))}
                {true ? (
                  <div className="row align-items-center mb-3">
                    <div className="col-md-5">
                      <div
                        className={`form-group ${this.errorClass(
                          this.state.formErrors[`PrenomNomTierceN`]
                        )}`}
                      >
                        <input
                          type="text"
                          className="form-control ipt-id-nom"
                          name="PrenomNomTierce"
                          onChange={(e) => this.onChangeAddTierce(e)}
                          placeholder={this.props.t('identite.firstname_lastname')}
                          value={this.state.newTierce.PrenomNomTierce}
                        />
                        {Object.keys(this.state.formErrors).map(
                          (fieldName, i) => {
                            if (
                              !_.isEmpty(this.state.formErrors[fieldName]) &&
                              `PrenomNomTierceN` === fieldName
                            ) {
                              return (
                                <p key={i}>
                                  {this.props.t('creche_form.name_and_firstname')}{" "}
                                  {this.state.formErrors[fieldName]}
                                </p>
                              );
                            } else if (
                              !_.isEmpty(this.state.formErrors["numeroTelN"]) &&
                              _.isEmpty(
                                this.state.formErrors["PrenomNomTierceN"]
                              )
                            ) {
                              return (
                                <p
                                  key={i}
                                  style={{
                                    marginTop: "45px",
                                  }}
                                ></p>
                              );
                            } else {
                              return "";
                            }
                          }
                        )}
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div
                        className={`form-group ${this.errorClass(
                          this.state.formErrors[`numeroTelN`]
                        )}`}
                      >
                        <input
                          type="text"
                          className="form-control ipt-id-tel"
                          name="numeroTel"
                          onChange={(e) => this.onChangeAddTierce(e)}
                          placeholder="xx xx xx xx xx"
                          value={this.state.newTierce.numeroTel}
                        />
                        {Object.keys(this.state.formErrors).map(
                          (fieldName, i) => {
                            if (
                              !_.isEmpty(this.state.formErrors[fieldName]) &&
                              `numeroTelN` === fieldName
                            ) {
                              return (
                                <p key={i}>
                                  {this.state.formErrors[fieldName]}
                                </p>
                              );
                            } else if (
                              !_.isEmpty(
                                this.state.formErrors["PrenomNomTierceN"]
                              ) &&
                              _.isEmpty(this.state.formErrors["numeroTelN"])
                            ) {
                              return (
                                <p
                                  key={i}
                                  style={{
                                    marginTop: "45px",
                                  }}
                                ></p>
                              );
                            } else {
                              return "";
                            }
                          }
                        )}
                      </div>
                    </div>
                    <div className="col-md-2 d-flex align-items-center">
                      <button
                        style={
                          !_.isEmpty(
                            this.state.formErrors["PrenomNomTierceN"]
                          ) || !_.isEmpty(this.state.formErrors["numeroTelN"])
                            ? { marginBottom: "45px" }
                            : {}
                        }
                        type="button"
                        className="action-line add"
                        onClick={this.showAddTierce}
                      ></button>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {this.state.showTierce ? (
                  <div className="row align-items-center mb-3"></div>
                ) : (
                  ""
                )}
              </section>
              <section className="content-section">
                <div className="d-flex justify-content-center">
                  <div className="row align-items-center md-5">
                    <div className="col-md-5">
                      <div className="form-group">
                        <button
                          onClick={this.openModalCancel}
                          type="submit"
                          className="btn-blue btn-valid"
                          data-toggle="modal"
                          data-target="#modalCancel"
                        >
                          {this.props.t('common.cancel')}
                        </button>
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className="form-group">
                        <button
                          onClick={this.validateSubmit}
                          type="submit"
                          className="btn-gradient btn-valid margin-left"
                          data-toggle="modal"
                          data-target="#modalConfirm"
                        >
                          {this.props.t('common.save')}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="bottom-space"></p>
              </section>
              {this.state.ModalePhoto ? (
                <ModalePhoto
                  onCloseModalePhoto={this.onCloseModalePhoto}
                  ModalePhoto={this.state.ModalePhoto}
                  uploadPhoto={this.uploadPhoto}
                  photo={this.state.lienPhoto}
                />
              ) : (
                ""
              )}
              {this.state.modalUploadMobile ? (
                <UploadMobile
                  photo={this.state.file}
                  onCloseUploadMobile={this.onCloseUploadMobile}
                  getCroppedImage={this.getCroppedImage}
                  uploadPhotoMobile={this.uploadPhotoMobile}
                />
              ) : null}
            </div>
          </div>
        </div>
        {this.state.showModalConfirm ? (
          <ModalConfirmAdd
            submit={this.confirmSubmit}
            close={this.closeModalConfirm}
          />
        ) : (
          ""
        )}

        {this.state.showModalCancel ? (
          <ModalCancelAdd close={this.closeModalCancel} />
        ) : (
          ""
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  account: state.auth.account,
  loading: state.auth.loading,
});

export default connect(mapStateToProps, { getAccount, postEnfantSimple })(
  withTranslation()(Creche)
);
